import { render, staticRenderFns } from "./AttentionCompany.vue?vue&type=template&id=4f755d76&scoped=true"
import script from "./AttentionCompany.vue?vue&type=script&lang=js"
export * from "./AttentionCompany.vue?vue&type=script&lang=js"
import style0 from "./AttentionCompany.vue?vue&type=style&index=0&id=4f755d76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f755d76",
  null
  
)

export default component.exports